<template>
  <div>
    <div class="i-layout-page-header">
      <div class="i-layout-page-header">
        <span class="ivu-page-header-title">{{$route.meta.title}}</span>
      </div>
    </div>
    <Card :bordered="false" dis-hover class="ivu-mt">
      <Form ref="userForm" :model="userForm"  :label-width="75" label-position="right" @submit.native.prevent>
        <Row type="flex" :gutter="24">
          <Col v-bind="grid">
            <FormItem label="文章名称："  label-for="key">
              <Input search enter-button placeholder="请输入" clearable v-model="userForm.key" @on-search="userSearchs">
              </Input>
            </FormItem>
          </Col>
        </Row>
        <Row type="flex">
          <Col>
            <Button type="primary"  icon="md-add" @click="add">添加轮播文章</Button>
          </Col>
        </Row>
      </Form>
      <Table :columns="columns2" :data="tableList" ref="table" class="ivu-mt"
             :loading="loading"
             no-userFrom-text="暂无数据"
             no-filtered-userFrom-text="暂无筛选结果"
      >
        <template slot-scope="{ row, index }" slot="sort">
          <InputNumber :min="0" v-model="row.sort" @on-blur="OnBlur(row)"/>
        </template>

        <template slot-scope="{ row, index }" slot="status">
          <i-switch v-model="row.status" :value="row.status" :true-value="1" :false-value="0" @on-change="changeSwitch(row)">
          </i-switch>
        </template>
        <template slot-scope="{ row, index }" slot="action">
          <a @click="edit(row.id)">编辑</a>
          <Divider type="vertical" />
          <a @click="del(row)">删除</a>
        </template>
      </Table>
      <Page :total="dataCount" :current="userForm.page" :page-size="userForm.limit" class="acea-row row-right page" show-total  @on-change="changepage"></Page>
    </Card>
    <modalSure ref="modalSure" :confirm="confirm" :id="article_id" title="文章" :modelApi="modelApi" @closeModal="closeModal"></modalSure>
  </div>
</template>

<script>
import { articleList, delNew, changeSort, changeStatus } from '@/api/article'
import modalSure from '@/components/modalSure'
export default {
  name: 'articleList',
  components: { modalSure },
  data () {
    return {
      userForm: {
        page: 1,
        limit: 10,
        type: 3,
        key: ''
      },
      grid: {
        xs: 24,
        sm: 24,
        md: 12,
        lg: 7,
        xl: 7
      },
      article_id: 0,
      editShow: false,
      confirm: false,
      dataCount: 0,
      max_sort: 0,
      modelApi: delNew,
      tableList: [],
      loading: false,
      userid: 0,
      columns2: [
        {
          title: 'id',
          key: 'id',
          minWidth: 80
        },
        {
          title: '文章标题',
          key: 'title',
          minWidth: 120
        },

        {
          title: '状态',
          slot: 'status',
          minWidth: 120
        },
        {
          title: '排序',
          slot: 'sort',
          minWidth: 100
        },
        {
          title: '创建时间',
          key: 'ctime',
          minWidth: 110
        },
        {
          title: '操作',
          slot: 'action',
          fixed: 'right',
          minWidth: 120
        }
      ]
    }
  },
  created () {
    this.articleList()
  },
  methods: {
    articleList () {
      this.loading = true
      articleList(this.userForm).then(res => {
        let data = res.data
        this.tableList = data.list
        this.dataCount = data.count
        this.loading = false
        this.max_sort = Math.max.apply(Math, this.tableList.map(item => { return item.sort }))
      }).catch(res => {
        this.loading = false
        this.$Message.error(res.msg)
      })
    },
    add () {
      this.$router.push({ path: '/admin/article3/form' })
    },
    // 分页
    changepage (status) {
      this.userForm.page = status
      this.articleList()
    },
    // 失去焦点，排序提交
    OnBlur (row) {
      let parm = { id: row.id, sort: row.sort }
      changeSort(parm).then(async res => {
        this.$Message.success('排序成功')
        this.articleList()
      }).catch(res => {
        this.$Message.error(res.msg)
      })
    },
    handImgurl(url){
      var str = url.replace(/.+\./, "");
      if(str === 'mp4'){
        return url+'?x-oss-process=video/snapshot,t_3000,f_jpg,w_60,m_fast'
      }else{
        return url
      }
    },
    // 表格搜索
    userSearchs () {
      this.userForm.page = 1
      this.articleList()
    },
    selectChange () {
      this.userForm.key = ''
    },
    changeSwitch (row) {
      changeStatus(row.id).then(async res => {
        this.$Message.success(res.msg)
        this.advertList()
      }).catch(res => {
        this.$Message.error(res.msg)
      })
    },
    edit (id) {
      this.$router.push({ path: '/admin/article3/form/' + id })
      // this.$router.push({ path: '/admin/article/form/' })
    },
    updateStatusModel (modalStatus) {
      this.editShow = modalStatus
      this.reload()
    },
    del (row) {
      this.article_id = row.id
      this.$refs.modalSure.isShow = true
    },
    closeModal () {
      this.articleList()
    }
  }
}
</script>
